/**
 * Skip Links Component
 * 
 * Provides skip navigation links for keyboard users.
 * These links are hidden visually but accessible to keyboard and screen reader users.
 */

import React from 'react';

/**
 * Skip Links - Hidden until focused
 * Allows keyboard users to skip to main content areas
 */
export function SkipLinks() {
  const handleClick = (e, targetId) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.setAttribute('tabindex', '-1');
      target.focus();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="skip-links-container">
      <a 
        href="#main-content" 
        className="skip-link"
        onClick={(e) => handleClick(e, 'main-content')}
      >
        Skip to main content
      </a>
      <a 
        href="#main-navigation" 
        className="skip-link"
        onClick={(e) => handleClick(e, 'main-navigation')}
      >
        Skip to navigation
      </a>
    </div>
  );
}

export default SkipLinks;
